export default __webpack_public_path__ + "static/media/FEMMINA_ICONA.1fc70c92.svg";